import * as React from 'react'
import {Plan} from '../plan'
import s from './desktop.scss'
import {Sidebar} from './sidebar'
import {DesktopProps} from '.'

export const Desktop = ({
  selectedSeat,
  selectedSeats,
  plan,
  onSeatClick,
  onRemoveClick,
  onCheckoutClick,
}: DesktopProps) => (
  <div className={s.container}>
    <Sidebar selectedSeats={selectedSeats} onRemoveClick={onRemoveClick} onCheckoutClick={onCheckoutClick} />
    <div className={s.planContainer}>
      <Plan selectedSeat={selectedSeat} selectedSeats={selectedSeats} plan={plan} onSeatClick={onSeatClick} />
    </div>
  </div>
)
